import api from "../../config/api";

const state = {
    allSchedules: null,
    locationMeta: null,
    report: null,
};
let latestSchedulesRequest = 0;

const mutations = {
    SET_ALLSCHEDULES(state, payload) {
        state.allSchedules = payload;
    },
    SET_LOCATION_META(state, payload) {
        state.locationMeta = payload;
    },
    SET_REPORT(state, payload) {
        state.report = payload;
    }
};

const actions = {
    clearAllSchedules({ commit }) {
        latestSchedulesRequest++;
        commit("SET_ALLSCHEDULES", null);
        commit("SET_LOCATION_META", null);
    },
    async getAllSchedules({ commit }, request) {
        const requestId = ++latestSchedulesRequest;
        const { locationid, publicLink = false } = typeof request === "object" && request !== null
            ? request : { locationid: request };
        commit("SET_ALLSCHEDULES", null);
        commit("SET_LOCATION_META", null);
        try {
            const response = await api.get("/viewactivities/upcoming-instances", {
                params: { locationid, days: 120, public_link: publicLink ? 1 : 0 },
            });
            if (requestId !== latestSchedulesRequest) return null;
            const data = response.data.data;
            if (!Number.isSafeInteger(Number(data?.location?.locationid))
                || Number(data.location.locationid) <= 0 || !Array.isArray(data?.activities)) {
                throw new Error("Invalid schedule response");
            }
            commit("SET_ALLSCHEDULES", data.activities);
            commit("SET_LOCATION_META", {
                location: data.location,
                organization: data.organization,
                user: data.user,
                is_logged_in: data.is_logged_in,
                can_view: data.can_view,
                consolidated_view_url: data.consolidated_view_url,
                date_range: data.date_range,
            });
            return data;
        } catch (error) {
            if (requestId === latestSchedulesRequest) {
                commit("SET_ALLSCHEDULES", null);
                commit("SET_LOCATION_META", null);
                commit("SET_ERROR", error.response?.data?.message || "Error in fetching schedules");
                commit("SET_LOADING", false);
            }
            throw error;
        }
    },
    async generateReport({ commit }, payload) {
        try {
            const response = await api.post('/viewactivitiesajax', {
                ...payload,
                showResponseMethod: payload.showResponseMethod ?? true,
            });
            commit("SET_REPORT", response.data.object);
            return response.data.object;
        } catch (error) {
            commit("SET_ERROR", error.response?.data?.message || "Error in generating report");
            throw error;
        }
    },
    async generateLocationReport({ commit }, payload) {
        try {
            const response = await api.post('/managelocationajax', {
                cmd: 'generatelocationPDF',
                locationid: payload.locationid,
                public_bool: payload.public_bool || '0',
                activityidsarray: payload.activityidsarray || [],
                activityinstanceidsarray: payload.activityinstanceidsarray || [],
                instanceworkgroupidsarray: payload.instanceworkgroupidsarray || [],
                reporttype: payload.reporttype || 'list',
                showDeclinedRecords: payload.showDeclinedRecords ?? false,
                showAssignmentStatus: payload.showAssignmentStatus ?? false,
                showWorkgroupDescription: payload.showWorkgroupDescription ?? false,
                showResponseMethod: payload.showResponseMethod ?? true,
            });
            commit("SET_REPORT", response.data.object);
            return response.data.object;
        } catch (error) {
            commit("SET_ERROR", error.response?.data?.message || "Error in generating location report");
            throw error;
        }
    },
};

const getters = {
    allSchedules: (state) => state.allSchedules,
    allSchedulesLocationMeta: (state) => state.locationMeta,
    report: (state) => state.report,
};

export default {
    state,
    mutations,
    actions,
    getters,
};